<div class="right-sidebar-component" [ngClass]="{ 'dfb-theme': (currentTheme === 'dfb' && !isFluid) }">
  <div class="arrow-down-open"></div>
  <div class="right-sidebar-component__header">
    <vnc-header (onLeftIconClick)="closeSidebar()" style="width:100%;" size="l"  title="{{ headerTitle | translate }}"
      [iconTemplate]="backIconTemplate" type="back">
    </vnc-header>
    <ng-template #backIconTemplate>
        <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20z" fill="#000" fill-rule="evenodd"/>
        </svg>
    </ng-template>
  </div>
  <div class="right-sidebar-component__info" *ngIf="activeEmail">
    <div class="contact-avatar">
        <vp-avatar [type]="'big-profile'" [user]="contact"> </vp-avatar>
        <div class="edit-button-header" *ngIf="contact?.email === currentUser?.email">
            <button class="edit-button" mat-button mat-fab (click)="openAvatarDialog()">
                <svg width="18px" height="18px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="Icon/product/edit" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="Icon-24px" transform="translate(3.000000, 2.997500)" fill="#ffffff">
                            <path d="M0,14.2525 L0,18.0025 L3.75,18.0025 L14.81,6.9425 L11.06,3.1925 L0,14.2525 L0,14.2525 Z M17.71,4.0425 C18.1,3.6525 18.1,3.0225 17.71,2.6325 L15.37,0.2925 C14.98,-0.0975 14.35,-0.0975 13.96,0.2925 L12.13,2.1225 L15.88,5.8725 L17.71,4.0425 L17.71,4.0425 Z" id="Shape"></path>
                        </g>
                    </g>
                </svg>
            </button>
        </div>
    </div>
    <div class="contact-info">
      <div class="contact-info__name">{{ fullName }}</div>
      <div class="contact-info__role">{{ contact?.email }}</div>
      <div *ngIf="(!!contact && contact.is_global === 'true')" class="chat-contact">{{ 'GLOBAL_CONTACT'| translate}}</div>
    </div>

  </div>
<div class="right-sidebar-component__tabs" *ngIf="activeEmail">
<vnc-profile *ngIf="contact?.email !== currentUser?.email" [translation]="translations" profileLabel="{{ 'PROFILE' | translate }}" hrLabel="{{ 'HR_DATA' | translate }}"
accountLabel="{{ 'ACCOUNT' | translate }}"
activityLabel="{{ 'ACTIVITY' | translate }}"
[ngClass]="{ 'dfb-theme': (currentTheme === 'dfb' && !isFluid) }"
(onCopy)="copyEmail($event)"
(openURL)="openURL($event)"
[hideAudio]="!contact?.jid"
[hideVideo]="!contact?.jid"
[hideChat]="!contact?.jid"
[hideEmail]="!contact?.jid && !contact?.email"
[hideTicket]="!isShowTicketOption"
[hideTask]="!isShowTaskOption"
[hideHR]="contact?.contains_hr_data !== 'true'"
[hideAccount]="!contact?.user_id"
(profileAction)="handleProfileAction($event)"
[activityTemplate]="activityTemplate"
[hideFiles]="true"
[hideChatInfo]="true"
[hideActivity]="false"
[maxTabs]="isLargeScreen ? 3 : 2"
[alignActionCenter]="true"
[profile]="contact"
></vnc-profile>
<vnc-profile *ngIf="contact?.email === currentUser?.email"
[translation]="translations"
profileLabel="{{ 'PROFILE' | translate }}"
hrLabel="{{ 'HR_DATA' | translate }}"
accountLabel="{{ 'ACCOUNT' | translate }}"
activityLabel="{{ 'ACTIVITY' | translate }}"
[ngClass]="{ 'dfb-theme': (currentTheme === 'dfb' && !isFluid) }"
(onCopy)="copyEmail($event)"
(openURL)="openURL($event)"
[hideAudio]="true"
[hideVideo]="true"
[hideChat]="true"
[hideEmail]="true"
[hideTicket]="!isShowTicketOption"
[hideTask]="!isShowTaskOption"
[hideHR]="contact?.contains_hr_data !== 'true'"
[hideAccount]="!contact?.user_id"
(profileAction)="handleProfileAction($event)"
[activityTemplate]="activityTemplate"
[hideFiles]="true"
[hideChatInfo]="true"
[hideActivity]="true"
[maxTabs]="isLargeScreen ? 3 : 2"
[alignActionCenter]="true"
[profile]="contact"
></vnc-profile>
</div>
  <div *ngIf="!activeEmail" class="list-mobile-calendar-view" [ngClass]="{ 'carbon-theme' : (currentTheme == 'carbon' && !isFluid), 'dfb-theme': (currentTheme === 'dfb' && !isFluid) }">
      <div *ngFor="let allevents of mobileEvents" style="position: relative;">
          <div class="heading mobile-heading-list-view" *ngIf="!isSameMonth(allevents.headingDate)"

          >{{allevents.headingDate | date: "LLLL y" : "": locale}}</div>
          <div *ngFor="let allData of allevents.data">
              <div class="date-event date-event-mobile">
                  <div class="left-div left-div-mobile" >
                      <div class="date date-mobile">
                              <div class="day" [ngClass]="{ 'today': isToday(allData.date) }">{{allData.date | date: "dd" : "": locale}}</div>
                              <div class="full_day" [ngClass]="{ 'today_full': isToday(allData.date) }">{{allData.date | date: "EE" : "": locale}}</div>
                      </div>
                  </div>
                  <div class="right-div right-div-mobile">
                      <div *ngFor="let event of allData.data" class="rel" (dblclick)="appointmentClick(event)">
                          <div class="cal-after-hour-start first-segment cal-hour-segment ng-star-inserted"></div>
                          <div class="cal-after-hour-start second-segment  cal-hour-segment ng-star-inserted" ></div>
                          <div class="main main-mobile" [hidden]="!isCalendarCheck(event?.folderId)">

                              <div class="detail"
                              style="height: 100%;"
                              [ngStyle]="{ background: getBackgroundColor( event.bgcolor), borderColor:  event.bgcolor }"
                               vpLongPress [timeout]="700">
                                  <div class="fb" style="border-top-left-radius: 8px; border-bottom-left-radius: 8px;"
                                  [class.cal-visibility-F]="checkInst(event) ? event?.inst[0]?.fba === 'F' : event?.fba === 'F'"
                                  [class.cal-visibility-T]="checkInst(event) ? event?.inst[0]?.fba === 'T' : event?.fba === 'T'"
                                  [class.cal-visibility-B]="checkInst(event) ? event?.inst[0]?.fba === 'B' : event?.fba === 'B'"
                                  [class.cal-visibility-O]="checkInst(event) ? event?.inst[0]?.fba === 'O' : event?.fba === 'O'">
                                  </div>
                                  <div class="title-div title-dev-mobile">
                                      <div class="detail-title detail-title-mobile">
                                          <span *ngIf="event.tn && event.tn !== ''" class="tag-section-day-view-mobile" >
                                              <mat-icon *ngIf="event.tn && event.tn !== '' && event.tn.split(',').length === 1" [style.color]="getTagColorByNames(event?.tn)"
                                              style="vertical-align: middle; font-size: 14px; height: 16px; width: 16px;"
                                              class="event-tag-item">local_offer</mat-icon>
                                              <ng-container [ngTemplateOutlet]="rainbowTagIcon" *ngIf="event.tn.split(',').length > 1" ></ng-container>
                                              <!-- <mat-icon class="mdi-16px margin-left" fontSet="mdi" fontIcon="mdi-tag"></mat-icon> -->
                                          </span>

                                          <span *ngIf="event.isRepeatAppt" class="recursive-section">
                                              <ng-container [ngTemplateOutlet]="recursiveIcon" >
                                              </ng-container>
                                          </span>
                                          <mat-icon *ngIf="event.class && event.class==='PRI'" class="private-event-icon">lock</mat-icon>

                                          <div class="title-sec">{{event.title}}</div>

                                      </div>
                                      <div *ngIf="event.allDay === false" class="duration">
                                          {{timeFormat(event.start, true)}} - {{timeFormat(event.end, true)}}

                                      </div>
                                      <div *ngIf="event.allDay === true" class="duration">
                                          {{'CALENDARS.ALL_DAY_TITLE' | translate}}
                                      </div>
                                      <div *ngIf="(event.participants && event.participants.length > 1) || haveMultipleParticipents(event)" class="participants">
                                         <ng-container [ngTemplateOutlet]="participantIcon"></ng-container>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>

<ng-template #activityTemplate>
  <div class="detail-contact ">
  <div class="recent-activity">
    <div class="search-talk-mail">
        <vnc-input [showClear]="true" [disableAutoFocus]="true" [focused]="false" leadingIconName="mdi-magnify"
            placeholder="{{ 'SEARCH' | translate }}" [form]="searchControl" clearTooltip="{{ 'CLOSE' | translate }}"></vnc-input>
    </div>
    <div class="chips-container">
        <vnc-chips (clickEvent)="onSelectedTabChangeActivity(0)" text="{{ 'ALL' | translate}}" [active]="activeIndex === 0" type="static" size="s"></vnc-chips>
        <vnc-chips (clickEvent)="onSelectedTabChangeActivity(1)" text="{{ 'CHATS' | translate}}" [active]="activeIndex === 1" type="static" size="s"></vnc-chips>
        <vnc-chips (clickEvent)="onSelectedTabChangeActivity(2)" text="{{ 'EMAIL' | translate}}" [active]="activeIndex === 2" type="static" size="s"></vnc-chips>
    </div>

    <div class="recent-contact-tab" *ngIf="activeIndex === 0">
        <div class="recent-items" *ngIf="!!searchResponse && !!searchResponse.docs && searchResponse.docs.length > 0 && !isLoading">
            <div class="recent-item" *ngFor="let item of searchResponse.docs" (click)="openRecentActivity(item)">
                <span *ngIf="item.type === 'talk' && !!item.chatType && item.chatType === 'chat'">
                    <div class="recen-item-inner">
                        <div class="left">
                            <div class="avatar-item">
                                <vp-avatar
                                    [user]="{firstLastCharacters: item.from.charAt(0), email: item.from, color: getBgAvatarColor(item.from), avatarURL: getAvatarUrl(item.from)}">
                                </vp-avatar>
                            </div>
                        </div>
                        <div class="right">
                            <div class="title">
                                <span class="title-content">{{ item.contentTxt}}</span>
                                <span class="item-type">
                                    <span *ngIf="item.type === 'talk' && !!item.chatType && item.chatType === 'chat'">
                                        <mat-icon class="mdi-14px" fontSet="mdi" fontIcon="mdi-message-outline"></mat-icon>

                                        {{'CHAT_LEBALE' | translate }}
                                    </span>
                                </span>
                            </div>
                            <div class="time">
                                {{ displayTime(item.createdDt) }}
                            </div>
                        </div>
                    </div>
                    <mat-divider></mat-divider>
                </span>
                <span *ngIf="item.type === 'mail'">
                    <div class="recen-item-inner">
                        <div class="left">
                            <div class="avatar-item">
                                <vp-avatar
                                    [user]="{firstLastCharacters: item.from.charAt(0), email: item.from, color: getBgAvatarColor(item.from), avatarURL: getAvatarUrl(item.from)}">
                                </vp-avatar>
                            </div>
                        </div>
                        <div class="right">
                            <div class="title">
                                <span class="title-content">{{ item.title}}</span>
                                <span class="item-type" *ngIf="item.type === 'mail'">
                                    <div style="display: flex;">
                                        <div style="margin: 0 4px;">
                                            <ng-container [ngTemplateOutlet]="emailIcon"></ng-container>
                                        </div>
                                        <div>{{ 'EMAIL_LBL' | translate }}</div>
                                    </div>
                                </span>
                            </div>
                            <div class="time">
                                {{ displayTime(item.createdDt) }}
                            </div>
                        </div>
                    </div>
                    <mat-divider></mat-divider>
                </span>
            </div>
        </div>
        <div class="no-data-message" *ngIf="(!searchResponse || !!searchResponse && searchResponse.docs && searchResponse.docs.length === 0) && !isLoading">
        {{ 'NO_DATA_TO_DISPLAY' | translate }}
        </div>
        <div *ngIf="isLoading" class="recent-contact-tab-loader">
            <vnc-loader-circular [color]="'blue'" [size]="'xs'"></vnc-loader-circular>
        </div>
    </div>
    <div class="recent-contact-tab" *ngIf="activeIndex === 1">
        <div class="recent-items" *ngIf="!!searchResponse && !!searchResponse.docs && searchResponse.docs.length > 0 && !isLoading">
            <div class="recent-item" *ngFor="let item of searchResponse.docs" (click)="openRecentActivity(item)">
                <span *ngIf="item.type === 'talk' && !!item.chatType && item.chatType === 'chat'">
                    <div class="recen-item-inner">
                        <div class="left">
                            <div class="avatar-item">
                                <vp-avatar
                                    [user]="{firstLastCharacters: item.from.charAt(0), email: item.from, color: getBgAvatarColor(item.from), avatarURL: getAvatarUrl(item.from)}">
                                </vp-avatar>
                            </div>
                        </div>
                        <div class="right">
                            <div class="title">
                                <span class="title-content">{{ item.contentTxt}}</span>
                                <span class="item-type">
                                    <span *ngIf="item.type === 'talk' && !!item.chatType && item.chatType === 'chat'">
                                        <mat-icon class="mdi-14px" fontSet="mdi" fontIcon="mdi-message-outline"></mat-icon>
                                        {{'CHAT_LEBALE' | translate }}
                                    </span>
                                </span>
                            </div>
                            <div class="time">
                                {{ displayTime(item.createdDt) }}
                            </div>
                        </div>
                    </div>
                    <mat-divider></mat-divider>
                </span>
            </div>
        </div>
        <div class="no-data-message" *ngIf="(!searchResponse || !!searchResponse && searchResponse.docs && searchResponse.docs.length === 0) && !isLoading">
        {{ 'NO_DATA_TO_DISPLAY' | translate }}
        </div>
        <div *ngIf="isLoading" class="recent-contact-tab-loader">
            <vnc-loader-circular [color]="'blue'" [size]="'xs'"></vnc-loader-circular>
        </div>
    </div>
    <div class="recent-contact-tab" *ngIf="activeIndex === 2">
        <div class="recent-items" *ngIf="!!searchResponse && !!searchResponse.docs && searchResponse.docs.length > 0 && !isLoading">
            <div class="recent-item" *ngFor="let item of searchResponse.docs" (click)="openRecentActivity(item)">
                <span *ngIf="item.type === 'mail'">
                    <div class="recen-item-inner">
                        <div class="left">
                            <div class="avatar-item">
                                <vp-avatar
                                    [user]="{firstLastCharacters: item.from.charAt(0), email: item.from, color: getBgAvatarColor(item.from), avatarURL: getAvatarUrl(item.from)}">
                                </vp-avatar>
                            </div>
                        </div>
                        <div class="right">
                            <div class="title">
                                <span class="title-content">{{ item.title}}</span>
                                <span class="item-type" *ngIf="item.type === 'mail'">
                                    <div style="display: flex;">
                                        <div style="margin: 0 4px;">
                                            <ng-container [ngTemplateOutlet]="emailIcon"></ng-container>
                                        </div>
                                        <div>{{ 'EMAIL_LBL' | translate }}</div>
                                    </div>
                                </span>
                            </div>
                            <div class="time">
                                {{ displayTime(item.createdDt) }}
                            </div>
                        </div>
                    </div>
                    <mat-divider></mat-divider>
                </span>
            </div>
        </div>
        <div class="no-data-message" *ngIf="(!searchResponse || !!searchResponse && searchResponse.docs && searchResponse.docs.length === 0) && !isLoading">
        {{ 'NO_DATA_TO_DISPLAY' | translate }}
        </div>
        <div *ngIf="isLoading" class="recent-contact-tab-loader">
            <vnc-loader-circular [color]="'blue'" [size]="'xs'"></vnc-loader-circular>
        </div>
    </div>
  </div>
  </div>
</ng-template>
<ng-template #participantIcon>
    <svg width="16px" height="16px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Icon/product/users-new" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <path d="M16.0200669,12 C17.2684805,12 18.6256389,12.2698679 20.0933947,12.802083 C21.6901796,13.3810846 22.6943144,14.3096583 22.9554613,15.5874988 L22.9904987,15.7921655 L23,15.9296875 L23,17 C23,17.5522847 22.5522847,18 22,18 C21.4477153,18 21,17.5522847 21,17 L21,16.018 L20.9890465,15.9596418 C20.8769203,15.4982387 20.4565107,15.0982351 19.6136736,14.7593992 L19.4116221,14.682292 C18.1502808,14.2249238 17.019145,14 16.0200669,14 C15.4790809,14 14.8973878,14.0659418 14.2753572,14.1990199 C14.6193671,14.604295 14.8490713,15.0669129 14.9554613,15.5874988 L14.9904987,15.7921655 L15,15.9296875 L15,18 C15,18.5522847 14.5522847,19 14,19 C13.4477153,19 13,18.5522847 13,18 L13,16.018 L12.9890465,15.9596418 C12.8855454,15.5337312 12.5193649,15.1601374 11.8007277,14.838678 L11.6136736,14.7593992 L11.4116221,14.682292 C10.1502808,14.2249238 9.01914495,14 8.02006689,14 C7.02016749,14 5.88120553,14.2252689 4.60551489,14.6833493 C3.61546028,15.0388623 3.13204451,15.4652381 3.01095357,15.9601165 L3,16.013 L3,18 C3,18.5522847 2.55228475,19 2,19 C1.44771525,19 1,18.5522847 1,18 L1,15.9296875 L1.00950129,15.7921655 C1.20198853,14.4057812 2.23452212,13.4097023 3.92960216,12.8010257 C5.40976437,12.2695228 6.77247466,12 8.02006689,12 C9.24476918,12 10.5741248,12.259714 12.0098825,12.7720416 L11.9296022,12.8010257 C13.4097644,12.2695228 14.7724747,12 16.0200669,12 Z M7.5,4 C8.47989383,4 9.33149097,4.33426357 9.99566698,4.99325071 C10.6613811,5.65376395 11,6.50303011 11,7.48046875 C11,8.45790739 10.6613811,9.30717355 9.99566698,9.96768679 C9.34169854,10.6165461 8.51178209,10.9642177 7.484272,10.9993728 C6.50450726,10.9646545 5.66056681,10.6187937 5.00433302,9.96768679 C4.33861889,9.30717355 4,8.45790739 4,7.48046875 C4,6.50303011 4.33861889,5.65376395 5.00433302,4.99325071 C5.66850903,4.33426357 6.52010617,4 7.5,4 Z M16.5,4 C17.4798938,4 18.331491,4.33426357 18.995667,4.99325071 C19.6613811,5.65376395 20,6.50303011 20,7.48046875 C20,8.45790739 19.6613811,9.30717355 18.995667,9.96768679 C18.3394332,10.6187937 17.4954927,10.9646545 16.4435921,10.9993255 C15.4882179,10.9642177 14.6583015,10.6165461 14.004333,9.96768679 C13.3386189,9.30717355 13,8.45790739 13,7.48046875 C13,6.50303011 13.3386189,5.65376395 14.004333,4.99325071 C14.668509,4.33426357 15.5201062,4 16.5,4 Z M7.5,6 C7.03632428,6 6.69369569,6.13448643 6.41298981,6.41299929 C6.13382206,6.68998605 6,7.02561572 6,7.48046875 C6,7.93532178 6.13382206,8.27095145 6.41298981,8.54793821 C6.70163792,8.83433125 7.06504655,8.98326213 7.48296214,9.00067451 C7.94491082,8.98369897 8.29609673,8.8365789 8.58701019,8.54793821 C8.86617794,8.27095145 9,7.93532178 9,7.48046875 C9,7.02561572 8.86617794,6.68998605 8.58701019,6.41299929 C8.30630431,6.13448643 7.96367572,6 7.5,6 Z M16.5,6 C16.0363243,6 15.6936957,6.13448643 15.4129898,6.41299929 C15.1338221,6.68998605 15,7.02561572 15,7.48046875 C15,7.93532178 15.1338221,8.27095145 15.4129898,8.54793821 C15.7039033,8.8365789 16.0550892,8.98369897 16.4449019,9.00062724 C16.9349535,8.98326213 17.2983621,8.83433125 17.5870102,8.54793821 C17.8661779,8.27095145 18,7.93532178 18,7.48046875 C18,7.02561572 17.8661779,6.68998605 17.5870102,6.41299929 C17.3063043,6.13448643 16.9636757,6 16.5,6 Z" id="Combined-Shape" fill="#000000"></path>
        </g>
    </svg>
</ng-template>
<ng-template #recursiveIcon>
    <svg width="16px" height="16px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Icon/product/autorenew" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Icon-24px" transform="translate(4.000000, 1.480291)" fill="#000000">
                <path d="M8,6.52075285 C8,7.07246132 8.31387329,7.20583612 8.70591205,6.81379735 L12,3.51970941 L8.70591205,0.22562146 C8.31604759,-0.164243002 8,-0.0376302616 8,0.518665968 L8,2.51970941 C3.58,2.51970941 0,6.09970941 0,10.5197094 C0,12.0897094 0.46,13.5497094 1.24,14.7797094 L2.7,13.3197094 C2.25,12.4897094 2,11.5297094 2,10.5197094 C2,7.20970941 4.69,4.51970941 8,4.51970941 L8,6.52075285 Z M13.3,7.71970941 C13.74,8.55970941 14,9.50970941 14,10.5197094 C14,13.8297094 11.31,16.5197094 8,16.5197094 L8,14.518666 C8,13.9669575 7.68612671,13.8335827 7.29408795,14.2256215 L4,17.5197094 L7.29408795,20.8137974 C7.68395241,21.2036618 8,21.0770491 8,20.5207528 L8,18.5197094 C12.42,18.5197094 16,14.9397094 16,10.5197094 C16,8.94970941 15.54,7.48970941 14.76,6.25970941 L13.3,7.71970941 Z" id="Shape"></path>
            </g>
        </g>
    </svg>
</ng-template>
<ng-template #emailIcon>
    <svg width="14px" height="14px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Icon/product/mail-new" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <path d="M19,4 C20.6568542,4 22,5.34314575 22,7 L22,17 C22,18.6568542 20.6568542,20 19,20 L5,20 C3.34314575,20 2,18.6568542 2,17 L2,7 C2,5.34314575 3.34314575,4 5,4 L19,4 Z M19.7744108,6.3672689 L14.1213203,12.0208153 C12.9497475,13.1923882 11.0502525,13.1923882 9.87867966,12.0208153 L4.22558922,6.3672689 C4.10776024,6.51131027 4.0293244,6.68882894 4.00672773,6.88337887 L4,7 L4,17 C4,17.5128358 4.38604019,17.9355072 4.88337887,17.9932723 L5,18 L19,18 C19.5128358,18 19.9355072,17.6139598 19.9932723,17.1166211 L20,17 L20,7 C20,6.75993895 19.91541,6.53963495 19.7744108,6.3672689 Z M17.314,6 L6.685,6 L11.2928932,10.6066017 C11.6555229,10.9692314 12.2273683,10.9951335 12.619886,10.6843081 L12.7071068,10.6066017 L17.314,6 Z" id="Combined-Shape" fill="#8B96A0"></path>
        </g>
    </svg>
</ng-template>